/* eslint-disable */
import React, { useState, useEffect, useRef } from 'react'
import classNames from 'classnames'
import { Spacer, Button } from '@cleartrip/bento'
import { sendClevertapUIActionEvent as ClevertapEvent } from 'AccountsUtils'
import OfflineToast from '../offlineToast'
import {
  verifyOtpForSignIn,
  sendOtpForSignIn
} from '../../../pages/Trips/trips.helper'
import OtpBox from './otpBox'
import USER_PROFILE_PAGE_CONTANTS from '../UserProfileConstants'

import { errorConfig } from './errorConfig'
import { invokeCustomEvent } from '../../../utils/index'
import { path } from '../../../utils/index'

const verifyEmailML = ({
  email,
  setPageName,
  userDetail,
  setIsGOpaque = () => { },
  setIsPOpaque = () => { },
  setIsEmailEditable = () => { },
  setIsMOpaque = () => { },
  setUserDetail,
  isEmailEditable,
  setToastMessagex = () => { },
  isEmailLinked
}) => {
  const animationDefaultState = {
    isAnimate: false,
    direction: 'right',
    isFadeIn: false
  }

  const refs = [useRef(), useRef(), useRef(), useRef(), useRef(), useRef()]

  const [otpDigits, setOtpDigits] = useState([])
  const [otpValidationError, setOtpValidationError] = useState('')
  const [apiError, setApiError] = useState('')
  const [countDown, setCountDown] = useState(30)
  const [retriesLeft, setRetriesLeft] = useState(4)
  const [animationParams, setAnimationParams] = useState(animationDefaultState)
  const [isLoading, setIsLoading] = useState(false)

  const animatedClass = classNames({
    'slide-in-right':
      animationParams.direction === 'right' && animationParams.isAnimate,
    'slide-in-left':
      animationParams.direction === 'left' && animationParams.isAnimate,
    'px-0': 'px-0'
  })
  // const query = resolveKeysInObjectsArrays(['location', 'pathname'], window)

  const getOtpValue = () => {
    const otp = otpDigits.join('')
    return otp
  }
  const countDownHandler = (countDown, lastCountdown = false) => {
    if (countDown === 0) {
    } else {
      if (countDown === 1) {
        if (lastCountdown) {
          setRetriesLeft(-1)
        }
      }
      const updatedCountDown = countDown - 1
      setCountDown(updatedCountDown)
      setTimeout(() => countDownHandler(updatedCountDown, lastCountdown), 1000)
    }
  }

  const disabled = getOtpValue().length !== 6

  useEffect(() => {
    refs[0] && refs[0].current && refs[0].current.focus()
    countDownHandler(30)
  }, [])

  const transformEmail = email => {
    const [userName, domain] = email.split('@')
    let censoredUsername = ''
    if (userName.length > 5) {
      censoredUsername =
        userName[0] +
        userName[1] +
        '*'.repeat(userName.length - 4) +
        userName.slice(-2)
    } else {
      switch (userName.length) {
        case 1:
          censoredUsername = '*'
          break
        case 2:
          censoredUsername = `${userName[0]}*`
          break
        case 3:
          censoredUsername = `${userName[0]}*${userName[2]}`
          break
        case 4:
          censoredUsername = userName[0] + '*'.repeat(2) + userName[3]
          break
        case 5:
          censoredUsername = userName[0] + '*'.repeat(3) + userName[4]
          break
      }
    }
    return `${censoredUsername}@${domain}`
  }
  const setElementInFocus = index => {
    refs[index] && refs[index].current && refs[index].current.focus()
  }

  const clearOtp = () => {
    const emptyOtpDigits = ['', '', '', '', '', '']
    setOtpDigits(emptyOtpDigits)

    refs[0] && refs[0].current && refs[0].current.focus()
  }
  const handleCancel = () => {
    setIsEmailEditable(true)

    setIsGOpaque(false)
    setIsPOpaque(false)
    setIsMOpaque(false)
  }

  const resendOtp = async () => {
    setApiError('')
    setOtpValidationError(false)
    // eslint-disable-next-line no-empty
    if (countDown !== 0 || retriesLeft <= 0) {
    } else {
      try {
        const payload = {
          type: 'EMAIL',
          value: email,
          action: 'UPDATE_EMAIL'
        }
        const response = await sendOtpForSignIn(payload)
        const { status, error } = response || {}
        if (status === 202) {
          clearOtp()
          countDownHandler(30)
        } else {
          const { response = { data: {} } } = error || {}
          const { data = {} } = response
          const { message } = data
          const err = errorConfig[message] || errorConfig.default
          setApiError(err)
          if (message === 'OTP_SEND_LIMIT_EXCEEDED') {
            setRetriesLeft(-1)
          }
        }
      } catch (e) {
        console.error('Resend api error', e)
      }
    }
  }
  const otpChangeHandler = (event, index) => {
    setApiError('')
    setOtpValidationError(false)
    const value = event.nativeEvent.data || event.target.value
    const numberValue = Number(value)
    if (value === ' ') return
    if (value === '') {
      const otpFieldValues = [...otpDigits]
      otpFieldValues[index] = ''
      setOtpDigits(otpFieldValues)
      return
    }
    if (numberValue >= 0 && Number.isInteger(numberValue)) {
      const otpFieldValues = [...otpDigits]
      otpFieldValues[index] = value % 10
      setOtpDigits(otpFieldValues)
      setElementInFocus(index + 1)
    }
  }
  const otpCursorHandler = (event, index) => {
    if (event.keyCode === 37) {
      setElementInFocus(index - 1)
    }
    if (event.keyCode === 39) {
      setElementInFocus(index + 1)
    }
    if (event.keyCode === 8) {
      if (event.target.value === '') {
        const otpFieldValues = [...otpDigits]
        const indexToRemove = index - 1
        if (indexToRemove < 0) {
          return
        }
        otpFieldValues[indexToRemove] = ''
        setOtpDigits(otpFieldValues)
        setElementInFocus(indexToRemove)
      } else {
        const otpFieldValues = [...otpDigits]
        otpFieldValues[index] = ''
        setOtpDigits(otpFieldValues)
      }
    }
  }
  const otpBlock = [1, 2, 3, 4, 5, 6].map((element, index) => {
    return (
      <OtpBox
        key={index}
        onKeyDown={e => otpCursorHandler(e, index)}
        onChange={e => otpChangeHandler(e, index)}
        onMouseDownCapture={() => {
          setElementInFocus(index)
        }}
        ref={refs[index]}
        value={otpDigits[index]}
        style={{
          margin: `11px ${index === 5 ? '0px' : '10px'} 14px 0px`,
          border: otpValidationError
            ? ' solid 1px #ff3c2b'
            : refs[index] && refs[index].current === document.activeElement
              ? 'solid 1px #36c'
              : 'solid 1px #e6e6e6'
        }}
      />
    )
  })

  const submitOtp = async () => {
    setIsLoading(true)
    const otp = getOtpValue()
    const payload = {
      type: 'EMAIL',
      value: email,
      action: 'UPDATE_EMAIL',
      otp
    }
    try {
      const response = await verifyOtpForSignIn(payload)
      const { status, error } = response || {}
      if (status === 200) {

      if (path(['androidData', 'app-agent'], window) && path(['androidData', 'js-version'], window)) {
        window.MobileApp.onPWALoginStatus(
            JSON.stringify({
                isSignIn: true
            })
        )
    }

      if (path(['iosData', 'app-agent'], window) && path(['iosData', 'js-version'], window)) {
          window.webkit.messageHandlers['PWA_IS_SIGNIN'].postMessage({
              isSignIn: true
          })
      }
        invokeCustomEvent('CLEVERTAP_PROFILE', { type: 'profileUpdate' })
        ClevertapEvent({
          action_name: 'email_updated_message',
          page_name: 'profile',
          platform: 'Desktop',
          is_logged_in: 'Yes',
          domainName: window && window.location.hostname
        })
        setUserDetail({ ...userDetail, username: email })
        {
          isEmailLinked
            ? (setToastMessagex(
              'The mobile number and email address have been merged successfully.'
            ),
              ClevertapEvent({
                action_name: 'mobile_and_email_merged_message',
                page_name: 'profile',
                platform: 'Desktop',
                is_logged_in: 'Yes',
                domainName: window && window.location.hostname
              }))
            : setToastMessagex('Email address has been updated')
        }
        setApiError('')
        setIsEmailEditable(true)
        setIsGOpaque(false)
        setIsPOpaque(false)
        setIsMOpaque(false)
        setUser
      } else {
        const { response = { data: {} } } = error || {}
        const { data = {} } = response
        const { message } = data
        const err = errorConfig[message] || errorConfig.default

        if (message === 'INVALID_OTP') {
          ClevertapEvent({
            action_name: 'invalid_otp_message',
            page_name: 'profile',
            platform: 'Desktop',
            is_logged_in: 'Yes',
            domainName: window && window.location.hostname
          })
          setOtpValidationError(err)
        } else if (
          message === 'ID_ALREADY_VERIFIED_WITH_SAME_DETAILS_AND_TYPE' ||
          message === 'EMAIL_ACCOUNT_IS_ALREADY_LINKED_TO_DIFFERENT_MOBILE'
        ) {
          setApiError(err)
          ClevertapEvent({
            action_name: ' email_exists_message',
            page_name: 'profile',
            platform: 'Desktop',
            is_logged_in: 'Yes',
            domainName: window && window.location.hostname
          })
        } else {
          setApiError(err)
        }
      }
    } catch (e) {
      setApiError('Something went wrong')
      console.error(e)
    }

    setIsLoading(false)
  }

  return (
    <div
      className="bg-white br-4 br-4 o-hidden d-flex flex-column px-0"
      style={{
        width: '450px',
        height: '468px'
      }}
    >
      <div
        onKeyDown={e => {
          if (e.key === 'Enter') {
            if (!disabled) {
              submitOtp()
            }
          }
        }}
        className={`${animatedClass} d-flex flex-1 flex-column`}
      >
        <span className="fs-4 fw-600"> Verify your email address</span>

        <OfflineToast page="verify email address" />

        <div className="d-flex flex-column flex-1 ml-1">
          <div>
            <Spacer className="pt-4" />
            <p className="fs-3 c-neutral-700">
              <span className="fs-3 c-neutral-700">
                {' '}
                {'Enter the OTP sent to '}{' '}
              </span>

              <span className="fs-3 c-neutral-700 fw-600">
                {`${transformEmail(email)}`}
              </span>
              <span
                style={{ marginTop: '-3px', color: 'blue' }}
                className="fs-2 fw-500"
                onClick={() => {
                  setPageName(USER_PROFILE_PAGE_CONTANTS.SIGNIN_EMAILML)
                }}
              >
                {'  Change'}
              </span>
            </p>
            <div className="d-flex">{otpBlock}</div>
            {otpValidationError && (
              <div className="c-error-500 mb-3" style={{ marginTop: '-8px' }}>
                {otpValidationError}
              </div>
            )}
            <div style={{ marginBottom: '29px' }}>
              <span className="fs-2 c-neutral-700">Haven't received OTP?</span>
              <span
                onClick={resendOtp}
                className={`fs-2 fw-500 ml-1 ${retriesLeft === -1
                  ? 'c-neutral-200'
                  : countDown !== 0
                    ? 'c-neutral-200'
                    : isLoading
                      ? 'c-neutral-200'
                      : 'c-blue c-pointer'
                  }`}
              >
                {retriesLeft === -1
                  ? 'Resend'
                  : countDown !== 0
                    ? `Resend (${countDown}s)`
                    : 'Resend'}
              </span>
            </div>
          </div>
          {apiError && (
            <div
              className="fw-500 fs-12 lh-16 mb-2"
              style={{ color: '#CC1414', marginTop: '-8px' }}
            >
              {apiError}
            </div>
          )}

          <div className="flex flex-row">
            <Button
              disabled={disabled}
              type="secondary"
              busy={isLoading}
              className="h-10 w-160 br-6-imp"
              onClick={submitOtp}
            >
              <span className={`${disabled ? 'c-grey-30' : ''} fs-14 fw-500 `}>
                {'Verify OTP'}
              </span>
            </Button>
            <a
              onClick={() => {
                handleCancel()
              }}
              className="fw-600 fs-14 lh-20 ml-12 mt-2"
            >
              Cancel
            </a>
          </div>
          <Spacer className="mb-8" />
        </div>
      </div>
    </div>
  )
}

export default verifyEmailML
